export const API_ERROR = "API_ERROR"
